import React, { FunctionComponent } from "react";
import { EnrollmentFormProps2022 } from "./EnrollmentFormPage";
import Enroll2022 from "./2022";
import { EnrollmentPages } from "../../helpers";

const CurrentFormPage: FunctionComponent<EnrollmentFormProps2022 & {
  currentPage: EnrollmentPages;
}> = props => {
  const components = {
    "2022": {
      [EnrollmentPages.Sep]: Enroll2022.SepEnrollments,
      [EnrollmentPages.MedicareInfo]: Enroll2022.MedicareInfo,
      [EnrollmentPages.Address]: Enroll2022.Address,
      [EnrollmentPages.PersonalInfo]: Enroll2022.PersonalInfo,
      [EnrollmentPages.GeneralQuestions]: Enroll2022.GeneralQuestions,
      [EnrollmentPages.Paying]: Enroll2022.Paying,
      [EnrollmentPages.Agreement]: Enroll2022.Agreement,
      [EnrollmentPages.Review]: Enroll2022.Review,
      [EnrollmentPages.Enrolled]: Enroll2022.Enrolled,
    },
  };

  /* istanbul ignore next: built-in functionality */
  const PageComponent = components[props.plan.contract_year][props.currentPage];

  if (!PageComponent) {
    return null;
  }

  return <PageComponent {...props} />;
};

export default CurrentFormPage;
